const propertyCard = {
  MX: `query PropertiesCard {
    allApipropertiesCards {
      edges {
        node {
          messagge {
            data {
              area
              bath
              zone_big
              title
              slug
              sale_price
              room
              published
              property_nid
              property_uuid
              property_moment_label
              property_moment_id
              property_id
              previous_price
              inventory_type_label
              inventory_type_id
              image_initial
              garage
              discount_rate
              discount
              city
              was_renovated
            }
            more_offset
            more_available
          }
        }
      }
    }
    allApipropertiesCardsMobile {
      edges {
        node {
          messagge {
            data {
              area
              bath
              zone_big
              title
              slug
              sale_price
              room
              published
              property_nid
              property_uuid
              property_moment_label
              property_moment_id
              property_id
              previous_price
              inventory_type_label
              inventory_type_id
              image_initial
              garage
              discount_rate
              discount
              city
              was_renovated
            }
            more_offset
            more_available
          }
        }
      }
    }
  }`,
  CO: `query PropertiesCard {
    allApipropertiesCards {
      edges {
        node {
          data {
            area
            bath
            zone_big
            title
            city
            garage
            slug
            room
            sale_price
            property_id
            property_nid
            discount_rate
            previous_price
            inventory_type_id
            property_moment_id
            image_initial
            property_uuid
          }
          more_offset
          more_available
        }
      }
    }
    allApipropertiesCardsMobile {
      edges {
        node {
          data {
            area
            bath
            zone_big
            title
            city
            garage
            slug
            room
            sale_price
            property_id
            property_nid
            discount_rate
            previous_price
            inventory_type_id
            property_moment_id
            image_initial
            property_uuid
          }
          more_offset
          more_available
        }
      }
    }
  }
`,
};

module.exports = { propertyCard };
